<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="12" md="6" lg="2">
      <FilterSearch :fetchData="fetchAppointments" />
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="2">
      <FilterAutocomplete
        :label="$t('appointment.filters.type')"
        :fetchData="fetchAppointments"
        :items="appointmentTypes"
        :item-text="'name'"
        type="type"
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterDate :fetchData="fetchAppointments" :dateRange="true" defaultRange="recent" ref="dateFilter" />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterAutocomplete
        :label="$t('appointment.filters.status')"
        :fetchData="fetchAppointments"
        :items="country === 'BR' ? defaultStatus : internationalStatus"
        type="status"
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterAutocomplete
        :label="$t('appointment.filters.branch')"
        :fetchData="fetchAppointments"
        :items="branches"
        type="branchId"
        value="id"
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterAutocomplete
        :label="$t('appointment.filters.cities')"
        :fetchData="fetchAppointments"
        :items="cities"
        type="citiesIds"
        value="id"
        multiple
      />
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <FilterAutocomplete
        :label="$t('appointment.filters.confirmed')"
        :fetchData="fetchAppointments"
        :items="confirmedOptions"
        type="confirmed"
        value="value"
      />
    </v-col>
  </v-row>
</template>

<script>
import FilterSearch from '@/components/filters/FilterSearch'
import FilterDate from '@/components/filters/FilterDate'
import FilterAutocomplete from '@/components/filters/FilterAutocomplete'

import { mapGetters, mapActions } from 'vuex'
import { isDraftAllowedBrazilianCustomer } from '../../util/customer';

export default {
  name: 'AppointmentListFilters',

  components: { FilterAutocomplete, FilterSearch, FilterDate },

  computed: {
    ...mapGetters(['appointmentTypes', 'branches', 'isLoading', 'cities', 'user']),

    country() {
      return this.user?.country ?? localStorage.getItem('user_country')
    }
  },

  methods: {
    ...mapActions([
      'fetchBranches',
      'fetchAppointments',
      'fetchAppointmentTypes',
      'fetchCities',
    ]),
  },

  data() {
    return {
      defaultStatus: [
        { value: 'DRAFT', name: this.$t('appointment.status.DRAFT') },
        { value: 'OPEN', name: this.$t('appointment.status.OPEN') },
        { value: 'SCHEDULED', name: this.$t('appointment.status.SCHEDULED') },
        { value: 'DONE', name: this.$t('appointment.status.DONE') },
        { value: 'CANCELED', name: this.$t('appointment.status.CANCELED') },
      ],

      internationalStatus: [
        { value: 'OPEN', name: this.$t('appointment.status.OPEN') },
        { value: 'SCHEDULED', name: this.$t('appointment.status.SCHEDULED') },
        { value: 'DONE', name: this.$t('appointment.status.DONE') },
        { value: 'CANCELED', name: this.$t('appointment.status.CANCELED') },
        { value: 'DRAFT', name: this.$t('appointment.status.DRAFT') },
        { value: 'REJECTED', name: this.$t('appointment.status.REJECTED') },
      ],

      confirmedOptions: [
        {
          name: this.$t('appointment.filters.confirmed'),
          value: true
        },
        {
          name: this.$t('appointment.filters.notConfirmed'),
          value: false
        },
      ],
    }
  },

  mounted() {
    this.fetchAppointmentTypes()
    this.fetchBranches()
    this.fetchCities()
    if (this.country === 'BR' && isDraftAllowedBrazilianCustomer()) {
      this.defaultStatus.push({ value: 'DRAFT', name: this.$t('appointment.status.DRAFT') })
    }
    this.$nextTick(() => {
      this.$refs.dateFilter?.selectDate('recent', 60)
    })
  },
}
</script>
